import React from "react";
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = ["#00C49F", "#FF8042"];

const UserTypeChart = ({ gameInfos }) => {
  const { t } = useTranslation();
  const counts = { Human: 0, AI: 0 };

  gameInfos.forEach((game) => {
    // const gameId = game.gameId;
    // if(gameId === "5b4e352c-2f97-4bb4-8c70-55126cd7aced" || gameId === "35c86e32-9c3d-4321-88f8-b39f12a98960" ){
    //   console.log("ai game");
    // }
    const type = game.opponentType;
    if (type === "Human" || type === "AIasHuman") {
      counts.Human++;
    } else if (type === "AI") {
      counts.AI++;
    }
  });

  const chartData = [
    { name: t("userType.Human"), value: counts.Human },
    { name: t("userType.AI"), value: counts.AI },
  ];

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "24px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        boxSizing: "border-box",
        position: "relative"
      }}
    >
      <h3 style={{
        marginBottom: "12px",
        fontSize: "1.25rem",
        fontWeight: "bold",
        textAlign: "center",
      }}>
        {t("chart.userTypeDistribution")}
      </h3>

      <div style={{ position: "relative", width: "100%", height: window.innerWidth < 600 ? "220px" : "300px" }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              outerRadius={100}
              innerRadius={60}
              label
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>

        {/* Center label */}
        <div style={{
          position: "absolute",
          top: "45%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "600",
          color: "#333"
        }}>
         {total}
        </div>
      </div>
    </div>
  );
};

export default UserTypeChart;
